import { FC } from 'react'
import cx from 'classnames'

import { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

export type PublicationGuideSmallCardProps = {
  className?: string
  title: string
  text: string
  button: ActionButtonProps
}

const PublicationGuideSmallCard: FC<PublicationGuideSmallCardProps> = ({
  className,
  title,
  text,
  button,
}) => {
  return (
    <SC.PublicationGuideSmallCard
      className={cx('PublicationGuideSmallCard', className)}
    >
      <SC.Wrapper>
        <SC.Title>{title}</SC.Title>
        <SC.Text>{text}</SC.Text>
      </SC.Wrapper>
      <SC.Button {...button} />
    </SC.PublicationGuideSmallCard>
  )
}

export default PublicationGuideSmallCard
